import {styled} from "@mui/material/styles";
import {DataGrid, gridClasses} from "@mui/x-data-grid";

export const StripedDataGrid = styled(DataGrid)(({theme}) => {
    const isDark = theme.palette.mode === "dark";
    return {
        border: 0,
        '.MuiDataGrid-toolbarContainer': {
            backgroundColor: theme.palette.newColors.gray,
            color: theme.palette.newColors.lightGray
        },
        '.MuiDataGrid-toolbarContainer > *': {
            color: theme.palette.newColors.lightGray
        },
        '.MuiTablePagination-toolbar': {
            color: theme.palette.newColors.lightGray,
            backgroundColor: theme.palette.newColors.gray,
        }
        , [`.${gridClasses.row}.even`]: {
            background: theme.palette.newColors.lightgray
        },
        [`.${gridClasses.row}.odd`]: {
            backgroundColor: theme.palette.newColors.lightGray
        },
        '.MuiDataGrid-columnHeaders div[role=row]:nth-of-type(1) .MuiDataGrid-columnHeader[role=columnheader]': {
            backgroundColor: theme.palette.newColors.lightGray,
            "& .MuiDataGrid-columnHeaderTitleContainerContent": {
                color: theme.palette.newColors.gray ,
            },
        },
        '.MuiDataGrid-columnHeaders div[role=row]:nth-of-type(2) .MuiDataGrid-columnHeader[role=columnheader]': {
            backgroundColor: theme.palette.newColors.gray,
            "& .MuiDataGrid-columnHeaderTitleContainerContent": {
                color: 'white',
            },
        },
        '.MuiDataGrid-columnHeaderTitleContainerContent ': {
            color: !isDark ? theme.palette.newColors.gray : 'white'
        }
        , '.MuiDataGrid-menuIcon > *': {
            color: 'white'
        }
        , '.MuiDataGrid-iconButtonContainer > *': {
            color: 'white'
        },
        '.MuiDataGrid-cell:nth-of-type(1)': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
        },
        // disable cell selection style
        '.MuiDataGrid-cell:focus': {
            outline: 'none'
        }
        // pointer cursor on ALL rows
        , '.MuiDataGrid-row:hover': {
            cursor: 'pointer'
        }
    }
})